import apiFetch from "@wordpress/api-fetch";
import { InsertResultName, InsertResultQuiz, Quiz } from "../../common/types";

type QuizBody = {
  body: Quiz[];
};

type InsertResultQuizBody = {
  body: InsertResultQuiz;
}


/**
 * 質問の取得
 */
function useGetQuiz(): (selectId: number) => Promise<Quiz[]> {

  const getQuiz = async (selectId: number) => {
    const result = await apiFetch({
      path: '/quiz-develop/v1/get_editor_config',
      method: 'POST',
      data: {
        body: {
          q_id: selectId,
        }
      }
    }).then((res: QuizBody) => {
      console.log(res);
      return res.body;
    }).catch((err) => {
      console.log(err);
      throw err;
    });
    return result
  }

  return getQuiz;
}

/**
 * すべてのクイズ結果の追加
 */
function useInsertResultName(): (insertResultQuizInput: InsertResultName) => Promise<InsertResultName> {

  const insertResultQuiz = async (insertResultQuizInput: InsertResultName) => {
    const result = await apiFetch({
      path: '/quiz-develop/v1/name/result/insert',
      method: 'POST',
      data: {
        body: {
          q_id: insertResultQuizInput.q_id,
          point: insertResultQuizInput.point,
        }
      }
    }).then((res: InsertResultQuizBody) => {
      console.log(res);
      return res.body;
    }).catch((e) => {
      console.log(e);
      throw e;
    });
    return result
  }

  return insertResultQuiz;
}

/**
 * 各クイズ結果の追加
 */
function useInsertResultQuiz(): (insertResultQuizInput: InsertResultQuiz) => Promise<InsertResultQuiz> {

  const insertResultQuiz = async (insertResultQuizInput: InsertResultQuiz) => {
    const result = await apiFetch({
      path: '/quiz-develop/v1/quiz/result/insert',
      method: 'POST',
      data: {
        body: {
          q_id: insertResultQuizInput.q_id,
          q_item_id: insertResultQuizInput.q_item_id,
          result: insertResultQuizInput.point,
        }
      }
    }).then((res: InsertResultQuizBody) => {
      console.log(res);
      return res.body;
    }).catch((e) => {
      console.log(e);
      throw e;
    });
    return result
  }

  return insertResultQuiz;
}



export { useGetQuiz, useInsertResultName, useInsertResultQuiz };